export const colors = {
  odd: "#311E84",
  even: "#FF5447",
  negative: "red",
};
